<!--
 * @Author: amywulan
 * @Date: 2020-04-24 17:04:07
 * @LastEditors: amywulan
 * @LastEditTime: 2020-09-16 14:43:34
 * @Description: 
-->
<template>
  <div class="mask" @click.stop="">
    <rich-loading/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
.mask
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  overflow auto
  margin 0
  display flex
  justify-content center
  align-items center
  z-index 11
</style>
